// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2W_bm","buttons":"SendReceipts_buttons__1ba-i","email":"SendReceipts_email__2CgW-","bookApptTitle":"SendReceipts_bookApptTitle__3HnX8"};